var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-chart',{attrs:{"check":false,"title":'Số lượng sinh viên',"sub-title1":'Tổng số SV',"sub-title2":'Tổng số SV đang học',"data-card":_vm.dataStudentOverview}})}
var staticRenderFns = []

export { render, staticRenderFns }